const defaultWorkflowVersion = 1;

const dev = {
  // Auth0 configuration is intentionally disabled until Auth0 is ready to be enabled.
  // auth0: {
  //   domain: "eatl-uk-dev.uk.auth0.com",
  //   clientId: "1OBYayIFiuCgjtMTOCXq68KKDJVvX5cl",
  // },
  apiGateway: {
    AUTH_API: "https://auth.sub360test.co.uk",
    META_API: "https://meta.sub360test.co.uk",
    DATA_API: "https://data.sub360test.co.uk",
    CONFIG_API: "https://lvcap.sub360test.co.uk",
    ALARMS_API: "https://alarms.sub360test.co.uk",
    WORK_API: "https://work.sub360test.co.uk",
    UTP2_API: "https://utp2.sub360test.co.uk",
    REQUEST_API: "https://requests.sub360test.co.uk",
    COLLABORA_API: "https://collabora.sub360test.co.uk",
  },
  defaultWorkflowVersion: defaultWorkflowVersion,
  reportsEnabled: true,
  flexiSurveysEnabled: true,
};

const beta = {
  apiGateway: {
    AUTH_API: "https://auth-beta.substation360.co.uk",
    META_API: "https://meta-beta.substation360.co.uk",
    DATA_API: "https://data-beta.substation360.co.uk",
    CONFIG_API: "https://lvcap-beta.substation360.co.uk",
    ALARMS_API: "https://alarms-beta.substation360.co.uk",
    WORK_API: "https://work-beta.substation360.co.uk",
    UTP2_API: "https://utp2-beta.substation360.co.uk",
    REQUEST_API: "https://requests-beta.substation360.co.uk",
    COLLABORA_API: "https://collabora-beta.substation360.co.uk",
  },
  defaultWorkflowVersion: defaultWorkflowVersion,
  reportsEnabled: true,
  flexiSurveysEnabled: true,
};

const prod = {
  apiGateway: {
    AUTH_API: "https://auth.substation360.co.uk",
    META_API: "https://meta.substation360.co.uk",
    DATA_API: "https://data.substation360.co.uk",
    CONFIG_API: "https://lvcap.substation360.co.uk",
    ALARMS_API: "https://alarms.substation360.co.uk",
    WORK_API: "https://work.substation360.co.uk",
    UTP2_API: "https://utp2.substation360.co.uk",
    REQUEST_API: "https://requests.substation360.co.uk",
    COLLABORA_API: "https://collabora.substation360.co.uk",
  },
  defaultWorkflowVersion: defaultWorkflowVersion,
  reportsEnabled: true,
  flexiSurveysEnabled: true,
};

const local = {
  // Auth0 configuration is intentionally disabled until Auth0 is ready to be enabled.
  // auth0: dev.auth0,
  apiGateway: {
    ...dev.apiGateway,
    //WORK_API: 'https://localhost:60070',
    //UTP2_API: "https://localhost:60072",
    //META_API: "https://localhost:7001",
  },
  defaultWorkflowVersion: defaultWorkflowVersion,
  reportsEnabled: true,
  flexiSurveysEnabled: true,
};

const loadEnvironmentConfig = () => {
  switch (process.env.REACT_APP_TARGET_ENV ?? process.env.NODE_ENV) {
    case "development":
      return dev;
    case "beta":
      return beta;
    case "production":
      return prod;
    case "local":
      return local;
    default:
      return dev;
  }
};
const config = loadEnvironmentConfig();

export default config;
